// @ts-nocheck
import { populate } from 'populate';
import type { Container, Graphics, Sprite, Text, NineSlicePlane } from 'pixi.js';
import { PiggyBankTitleLocalizationsLayout } from './PiggyBankTitleLocalizationsLayout';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';
import { PiggyBankLayout } from './PiggyBankLayout';
import { PiggyBankSmallLayout } from './PiggyBankSmallLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '',
    },
    {
      id: '506e9aab-87ab-492e-80e9-f138ebebf418',
      type: 'Container',
      name: 'redBackgroundContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
    },
    {
      id: 'f316a915-84de-44d8-9350-b23f411d7a4a',
      type: 'Container',
      name: 'blueBackgroundContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
    },
    {
      id: 'eb57168e-7702-462b-9be1-7cefeac378f8',
      type: 'Container',
      name: 'foreground',
      className: '',
      x: 390,
      y: 640,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
    },
    {
      id: '7b395d90-fc5a-46f9-bd6f-37bce3f6f650',
      type: 'Container',
      name: 'coinCounterSlot',
      className: '',
      x: 14,
      y: 21,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
    },
    {
      id: '2bff8c73-d789-4714-b196-f1d0bad2341b',
      type: 'Graphics',
      name: 'redBackground',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '506e9aab-87ab-492e-80e9-f138ebebf418',
      commands: [
        {
          id: '8ef2ca06-3bf9-4741-83b8-fddb3fe1a453',
          type: 'beginFill',
          color: 16711680,
          alpha: 1,
        },
        {
          id: '76686570-bb15-4398-8518-38b369388fd8',
          type: 'drawRect',
          x: 0,
          y: 0,
          width: 780,
          height: 1280,
        },
        {
          id: '40b3f0ec-549d-42ac-b636-6f092336ff54',
          type: 'beginFill',
          color: 0,
          alpha: 1,
        },
      ],
      data: {
        dynamicValues: {
          width: 'width',
          height: 'height',
        },
      },
    },
    {
      id: '53f59443-783d-4927-b3cc-149742d9f139',
      type: 'Sprite',
      name: 'redGradient',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 15.6,
        y: 2,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Gradient_Red',
      parent: '506e9aab-87ab-492e-80e9-f138ebebf418',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1',
        },
      },
    },
    {
      id: 'ff502dc9-f233-4210-834a-9b041942e06f',
      type: 'Graphics',
      name: 'blueBackground',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'f316a915-84de-44d8-9350-b23f411d7a4a',
      commands: [
        {
          id: '8ef2ca06-3bf9-4741-83b8-fddb3fe1a453',
          type: 'beginFill',
          color: 255,
          alpha: 1,
        },
        {
          id: '76686570-bb15-4398-8518-38b369388fd8',
          type: 'drawRect',
          x: 0,
          y: 0,
          width: 780,
          height: 1280,
        },
        {
          id: '40b3f0ec-549d-42ac-b636-6f092336ff54',
          type: 'beginFill',
          color: 0,
          alpha: 1,
        },
      ],
      data: {
        dynamicValues: {
          width: 'width',
          height: 'height',
        },
      },
    },
    {
      id: '649bb9cd-4883-47a4-8886-f00b9e9d9dd8',
      type: 'Sprite',
      name: 'blueGradient',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 15.6,
        y: 2,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: 'f316a915-84de-44d8-9350-b23f411d7a4a',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1',
        },
      },
    },
    {
      id: 'c06cb5b3-f4ff-4676-9f39-aab4686f9a12',
      type: 'Layout',
      name: 'logo',
      className: '',
      path: 'piggybank/PiggyBankTitleLocalizationsLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -454,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
    },
    {
      id: 'e5338ae8-88ff-4582-afa6-e181b6c16912',
      type: 'Container',
      name: 'raysContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
    },
    {
      id: '783d74fc-09f6-4886-81b8-17bae99bd059',
      type: 'Graphics',
      name: 'raysMask',
      className: '',
      x: -391,
      y: -869,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
      commands: [
        {
          id: '29c8476e-41a2-4886-aa11-d208cfa7e17e',
          type: 'beginFill',
          color: 16777215,
          alpha: 1,
        },
        {
          id: '2c4d89eb-d1be-443a-9bc4-6aeb7aaadc0c',
          type: 'drawRect',
          x: 0,
          y: 0,
          width: 780,
          height: 1000,
        },
        {
          id: 'c1bdd700-5067-4838-b7f1-03dd612c1a03',
          type: 'beginFill',
          color: 16777215,
          alpha: 1,
        },
      ],
    },
    {
      id: '51c95617-cbec-41ce-8993-b2bebb811293',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 15,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 3.577587,
        y: 2.551724,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16704813,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'circle_128_blur',
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
    },
    {
      id: '3205c4b4-b2a6-4543-9155-632806a7378d',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -18,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 2.801724,
        y: 2.5,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'circle_128_blur',
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
    },
    {
      id: '191d629a-4b02-4bfb-9963-8fb55033d1d8',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 338,
      y: -575,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      texture: 'Shop_Close_Button',
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
      stateByName: {
        inProgressAnimation: {
          visible: false,
        },
        inClaimAnimation: {
          visible: false,
        },
      },
    },
    {
      id: 'ef70e4ab-b18e-4a54-a683-27137286e058',
      type: 'Text',
      name: 'ctaText',
      className: '',
      x: 0,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      text: 'Win more Levels to fill up the Piggy Bank',
      localize: true,
      maxWidth: 636,
      maxHeight: 138,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 520,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
      stateByName: {
        inClaimAnimation: {
          visible: false,
        },
        inProgressAnimation: {
          visible: false,
        },
        claimable: {
          text: 'Break the Piggy Bank to claim the Coins!',
        },
        unclaimable_tier: {
          y: 410,
        },
        claimable_tier: {
          visible: false,
        },
        claimable_lastChance: {
          visible: false,
        },
      },
    },
    {
      id: 'b61bbd22-3112-442d-b38b-64188bc89c37',
      type: 'Container',
      name: 'lastChanceContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
      stateByName: {
        claimable_lastChance: {
          visible: true,
        },
        claimable: {
          visible: false,
        },
        unclaimable: {
          visible: false,
        },
        inProgressAnimation: {
          visible: false,
        },
        unclaimable_tier: {
          visible: false,
        },
        claimable_tier: {
          visible: false,
        },
      },
    },
    {
      id: '6ef9c78c-bc99-48e4-b353-cda7a5f87672',
      type: 'Container',
      name: 'stickerContainer',
      className: '',
      x: -300,
      y: -396,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
      stateByName: {
        unclaimable_tier: {
          y: -115,
          visible: false,
        },
        claimable_tier: {
          y: 390,
          x: 250,
        },
        claimable_lastChance: {
          y: 470,
          x: 250,
        },
        inProgressAnimation: {
          visible: false,
        },
        inClaimAnimation: {
          visible: false,
        },
      },
    },
    {
      id: '1af93999-400d-4bf0-b6d3-b9611c5ca889',
      type: 'Container',
      name: 'content',
      className: '',
      x: 0,
      y: 17,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
    },
    {
      id: '9c01af19-3ad4-41b5-82e8-a88ada4e2909',
      type: 'Container',
      name: 'progressBarContainer',
      className: '',
      x: 0,
      y: -284,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
    },
    {
      id: 'c964cf76-f1bc-4567-9b6e-2dfeabd04b00',
      type: 'Layout',
      name: 'claimButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 490,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: true,
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click',
      },
      stateByName: {
        unclaimable: {
          visible: false,
        },
        inProgressAnimation: {
          visible: false,
        },
        inClaimAnimation: {
          visible: false,
        },
        claimable_tier: {
          y: 430,
        },
        claimable_lastChance: {
          visible: false,
        },
      },
    },
    {
      id: '14236aad-f358-436a-8fe4-45fbac3df6c0',
      type: 'Layout',
      name: 'playButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 490,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click',
      },
      stateByName: {
        claimable: {
          visible: false,
        },
        unclaimable: {
          visible: true,
        },
        inProgressAnimation: {
          visible: false,
        },
        inClaimAnimation: {
          visible: false,
        },
        unclaimable_tier: {
          y: 530,
        },
        claimable_tier: {
          visible: false,
        },
        claimable_lastChance: {
          visible: false,
        },
      },
    },
    {
      id: 'f9d78c4f-6323-4beb-8238-1020b6e94f9e',
      type: 'Container',
      name: 'particleLayerSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
    },
    {
      id: 'cd2763ba-1599-4937-8627-b56dd11ab705',
      type: 'Container',
      name: 'rewardContainer',
      className: '',
      x: 0,
      y: -36,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
    },
    {
      id: '2fd6f0b2-3e6b-4b2c-bdbe-633e3ab54fd8',
      type: 'Container',
      name: 'coinParticleSlot',
      className: '',
      x: 0,
      y: -76,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
    },
    {
      id: '712bda6d-4b77-444a-aed4-4100f211d1f0',
      type: 'Container',
      name: 'timerContainer',
      className: '',
      x: 0,
      y: 280,
      scale: {
        x: 0.85,
        y: 0.85,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
      stateByName: {
        claimable: {
          visible: false,
        },
        unclaimable: {
          visible: false,
        },
        inProgressAnimation: {
          visible: false,
        },
        inClaimAnimation: {
          visible: false,
        },
        claimable_lastChance: {
          visible: false,
        },
      },
    },
    {
      id: '3c6b1ad0-a37d-44b7-89d7-39927db21d17',
      type: 'Container',
      name: 'nextTierContainer',
      className: '',
      x: 0,
      y: 540,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 0,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'eb57168e-7702-462b-9be1-7cefeac378f8',
      stateByName: {
        claimable: {
          visible: false,
        },
        unclaimable: {
          visible: false,
        },
        inProgressAnimation: {
          visible: false,
        },
        inClaimAnimation: {
          visible: false,
        },
        unclaimable_tier: {
          visible: false,
        },
        claimable_lastChance: {
          visible: false,
        },
      },
    },
    {
      id: '01f764bc-b619-485d-bb7e-fb031d35896a',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: 29,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 2.310231,
        y: 2.310231,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16704813,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'New_Rays',
      parent: 'e5338ae8-88ff-4582-afa6-e181b6c16912',
      data: {
        rotationCycle: 50000,
      },
    },
    {
      id: '9e6e8e41-a80d-465c-a66f-72fb5970a82d',
      type: 'Text',
      name: '',
      className: 'colorTags_SPL',
      x: 0,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'The Piggy Bank is about to be reset!\\nBreak it now or lose all the Gold!',
      localize: true,
      maxWidth: 600,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 550,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'b61bbd22-3112-442d-b38b-64188bc89c37',
      data: {
        colorTags: {
          '*': '#52defa',
        },
      },
      stateByName: {
        claimable_lastChance: {
          y: 340,
          maxWidth: 622,
          maxHeight: 101,
          style: {
            wordWrap: true,
            wordWrapWidth: 620,
            fontSize: 32,
          },
        },
        inClaimAnimation: {
          visible: false,
        },
      },
    },
    {
      id: 'c294edbf-39b6-445f-9cb0-57e5dce49f6c',
      type: 'Container',
      name: '',
      className: '',
      x: -26,
      y: -183,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'b61bbd22-3112-442d-b38b-64188bc89c37',
    },
    {
      id: '12a70731-d13f-491c-b67f-878e1e591bbe',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Sticker_Red',
      parent: '6ef9c78c-bc99-48e4-b353-cda7a5f87672',
      stateByName: {
        claimable_lastChance: {
          texture: 'Value_Badge_Blue',
        },
        claimable_tier: {
          alpha: 0,
        },
      },
    },
    {
      id: 'c0b4e04e-62d5-48a6-8c6a-0d1f4d536c11',
      type: 'Container',
      name: '',
      className: '',
      x: 3,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: -18.6,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '6ef9c78c-bc99-48e4-b353-cda7a5f87672',
      stateByName: {
        claimable_tier: {
          angle: 18.8,
          alpha: 0,
        },
        claimable_lastChance: {
          angle: 18.6,
        },
      },
    },
    {
      id: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
      type: 'Container',
      name: 'coinsEmpty',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '1af93999-400d-4bf0-b6d3-b9611c5ca889',
      stateByName: {
        claimable: {
          visible: true,
        },
        inProgressAnimation: {
          visible: true,
        },
        unclaimable: {
          visible: true,
        },
      },
    },
    {
      id: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
      type: 'Container',
      name: 'coinsFull',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '1af93999-400d-4bf0-b6d3-b9611c5ca889',
      stateByName: {
        claimable: {
          visible: true,
        },
        inClaimAnimation: {
          visible: true,
        },
      },
    },
    {
      id: 'e7fb2fd6-00c9-4b3c-aedf-afd72e110be5',
      type: 'Layout',
      name: 'pigLayout',
      className: '',
      path: 'piggybank/PiggyBankLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '1af93999-400d-4bf0-b6d3-b9611c5ca889',
    },
    {
      id: '2e45d95f-181a-466d-b08b-c62a12e18eb6',
      type: 'Container',
      name: 'pigSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '1af93999-400d-4bf0-b6d3-b9611c5ca889',
    },
    {
      id: '00e2cd96-6241-4b62-ba55-733bd984547b',
      type: 'Sprite',
      name: 'speechBubble',
      className: '',
      x: -235,
      y: -125,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Speech_Bubble',
      parent: '1af93999-400d-4bf0-b6d3-b9611c5ca889',
      stateByName: {
        unclaimable: {
          visible: false,
        },
        inProgressAnimation: {
          visible: false,
        },
        inClaimAnimation: {
          visible: false,
        },
        unclaimable_tier: {
          visible: false,
        },
        claimable_tier: {
          x: 144,
          scale: {
            x: -0.7,
            y: 0.7,
          },
          y: -158,
        },
        claimable_lastChance: {
          x: 235,
          scale: {
            x: -1,
          },
          visible: false,
        },
      },
    },
    {
      id: '6797a4f5-c4f0-4470-81d8-098b90dbc941',
      type: 'Text',
      name: '',
      className: '',
      x: -235,
      y: -138,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      text: 'FULL!',
      localize: true,
      maxWidth: 170,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8D2400',
        stroke: '#8D2400',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '1af93999-400d-4bf0-b6d3-b9611c5ca889',
      stateByName: {
        unclaimable: {
          visible: false,
        },
        inProgressAnimation: {
          visible: false,
        },
        inClaimAnimation: {
          visible: false,
        },
        unclaimable_tier: {
          visible: false,
        },
        claimable_tier: {
          x: 147,
          style: {
            fontSize: 36,
          },
          y: -168,
          maxWidth: 100,
          visible: false,
        },
        claimable_lastChance: {
          x: 235,
          visible: false,
          maxWidth: 115,
        },
      },
    },
    {
      id: '1b327252-9697-448f-909f-c0f2a5daabab',
      type: 'Text',
      name: 'fullTextSmall',
      className: '',
      x: -235,
      y: -138,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      text: 'FULL!',
      localize: true,
      maxWidth: 135,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8D2400',
        stroke: '#8D2400',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '1af93999-400d-4bf0-b6d3-b9611c5ca889',
      stateByName: {
        unclaimable: {
          visible: false,
        },
        inProgressAnimation: {
          visible: false,
        },
        inClaimAnimation: {
          visible: false,
        },
        unclaimable_tier: {
          visible: false,
        },
        claimable_tier: {
          x: 147,
          y: -168,
          visible: true,
        },
        claimable_lastChance: {
          x: 235,
          visible: false,
          maxWidth: 115,
        },
        claimable: {
          visible: false,
        },
      },
    },
    {
      id: 'b935e0a1-6f45-4c22-9cf8-1ab451d931c6',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -260,
      y: -47,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      width: 520,
      height: 92,
      leftWidth: 32,
      topHeight: 30,
      rightWidth: 32,
      bottomHeight: 35,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coins_Counter_Background_9Slice_32x30x32x35',
      parent: '9c01af19-3ad4-41b5-82e8-a88ada4e2909',
    },
    {
      id: 'a16e384a-a1cc-4bb7-a01e-b012a55b97b7',
      type: 'Container',
      name: '',
      className: '',
      x: -250,
      y: -45,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '9c01af19-3ad4-41b5-82e8-a88ada4e2909',
    },
    {
      id: 'c1d5829b-9712-4ea5-b2e3-a5c66f8599f9',
      type: 'Sprite',
      name: '',
      className: '',
      x: -209,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Coin_Icon',
      parent: '9c01af19-3ad4-41b5-82e8-a88ada4e2909',
    },
    {
      id: '7801c385-2a72-4efa-ad61-33cc1779a395',
      type: 'Text',
      name: '',
      className: 'upperCase_SPL',
      x: -30,
      y: -5,
      anchor: {
        x: 0,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Claim',
      localize: true,
      maxWidth: 160,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0038f0',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'c964cf76-f1bc-4567-9b6e-2dfeabd04b00',
    },
    {
      id: 'ddd4f2c8-a530-418c-b6de-38706adf8b22',
      type: 'Sprite',
      name: '',
      className: '',
      x: -80,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Watch_Ad_Icon_Blue',
      parent: 'c964cf76-f1bc-4567-9b6e-2dfeabd04b00',
    },
    {
      id: '941d8e67-9175-4be6-90ef-714f57ff9c59',
      type: 'Text',
      name: 'claimButtonText',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: '',
      localize: false,
      maxWidth: 265,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 55,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x006f0d',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'c964cf76-f1bc-4567-9b6e-2dfeabd04b00',
      stateByName: {
        unclaimable: {
          style: {
            stroke: '0x555555',
          },
          alpha: 0.7,
        },
      },
    },
    {
      id: '00136403-7350-436a-9876-ff8870465d7e',
      type: 'Container',
      name: 'loadingSpinnerSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'c964cf76-f1bc-4567-9b6e-2dfeabd04b00',
    },
    {
      id: '65f9711f-f685-442c-ae51-9d5c5b87ff8a',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Play',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x00700c',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '14236aad-f358-436a-8fe4-45fbac3df6c0',
    },
    {
      id: 'c2b9d1ac-4f1a-444f-bf92-c3d45b1ac04d',
      type: 'Text',
      name: 'playButtonLevelText',
      className: '',
      x: 0,
      y: 26,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'LEVEL 20',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '0x00700c',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '14236aad-f358-436a-8fe4-45fbac3df6c0',
    },
    {
      id: '84852dab-1f4a-41b4-a5c4-88685cf82a48',
      type: 'Sprite',
      name: 'coinSprite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 2.6,
        y: 2.56,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Coin_Icon',
      parent: 'cd2763ba-1599-4937-8627-b56dd11ab705',
    },
    {
      id: 'f2473f11-5973-4cb3-911e-9b511b4f20b4',
      type: 'Text',
      name: 'coinsAmountText',
      className: '',
      x: 0,
      y: 142,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'X700',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 90,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#450702',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'cd2763ba-1599-4937-8627-b56dd11ab705',
    },
    {
      id: '88f5cd77-6e75-4b39-9df0-e966eb1dce7a',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -150,
      y: -32,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      width: 300,
      height: 64,
      leftWidth: 30,
      topHeight: 10,
      rightWidth: 30,
      bottomHeight: 10,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Goal_Background',
      parent: '712bda6d-4b77-444a-aed4-4100f211d1f0',
    },
    {
      id: 'e071dea1-51df-4d02-ba92-59253d670fe6',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 22,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'XXh YYm',
      localize: false,
      maxWidth: 144,
      maxHeight: 61,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '712bda6d-4b77-444a-aed4-4100f211d1f0',
    },
    {
      id: '0a58336a-b5e0-4ef7-985e-f95ff2429082',
      type: 'Sprite',
      name: '',
      className: '',
      x: -116,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Golden_Clock',
      parent: '712bda6d-4b77-444a-aed4-4100f211d1f0',
    },
    {
      id: '5edadff0-cf27-4789-afdf-4b18545296a0',
      type: 'Text',
      name: 'emptyText',
      className: '',
      x: 0,
      y: -45,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      text: 'Empties in...',
      localize: true,
      maxWidth: 636,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 520,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '712bda6d-4b77-444a-aed4-4100f211d1f0',
      stateByName: {
        inClaimAnimation: {
          visible: false,
        },
        inProgressAnimation: {
          visible: false,
        },
        claimable: {
          text: 'Break the Piggy Bank to claim the Coins!',
        },
      },
    },
    {
      id: '32a24bc1-2a62-4c44-8286-d088766ac435',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1.1,
        y: 1.1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Next_Piggy_Bank_Background',
      parent: '3c6b1ad0-a37d-44b7-89d7-39927db21d17',
      stateByName: {
        claimable_tier: {
          alpha: 0,
        },
      },
    },
    {
      id: 'a46f68ac-eace-4a75-8f1b-5468ba88ed0e',
      type: 'Text',
      name: '',
      className: '',
      x: -51,
      y: 4,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Buy now to upgrade!',
      localize: true,
      maxWidth: 290,
      maxHeight: 65,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 300,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '3c6b1ad0-a37d-44b7-89d7-39927db21d17',
      stateByName: {
        claimable_tier: {
          alpha: 0,
        },
      },
    },
    {
      id: 'f4bc09a1-d6a1-4bfc-a9ba-4f7b16463a7e',
      type: 'Layout',
      name: 'nextTierLayout',
      className: '',
      path: 'piggybank/PiggyBankSmallLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 164,
      y: -24,
      scale: {
        x: 0.45,
        y: 0.45,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '3c6b1ad0-a37d-44b7-89d7-39927db21d17',
    },
    {
      id: '286bba4c-79cb-4d32-a390-22c3013c0064',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Last_Chance_Banner_Middle',
      parent: 'c294edbf-39b6-445f-9cb0-57e5dce49f6c',
    },
    {
      id: 'd21b1828-5fd8-45f7-8a90-e60616e369d5',
      type: 'Sprite',
      name: '',
      className: '',
      x: -190,
      y: -8,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Last_Chance_Banner_Left',
      parent: 'c294edbf-39b6-445f-9cb0-57e5dce49f6c',
    },
    {
      id: '25678e9e-276d-4fc7-b539-1c5b0e1448a8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 187,
      y: 8,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1.366379,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Last_Chance_Banner_Right',
      parent: 'c294edbf-39b6-445f-9cb0-57e5dce49f6c',
    },
    {
      id: 'fd823e55-c9fb-42b5-9b55-b3bb696a8fee',
      type: 'Text',
      name: '',
      className: '',
      x: -17,
      y: -14,
      anchor: {
        x: 1,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'LAST',
      localize: true,
      maxWidth: 244,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 58,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#DA1730',
        strokeThickness: 5,
        align: 'right',
        wordWrap: false,
        wordWrapWidth: 660,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'c294edbf-39b6-445f-9cb0-57e5dce49f6c',
    },
    {
      id: '1a63b7ac-5320-4213-b0b3-26d74ad46c59',
      type: 'Text',
      name: '',
      className: '',
      x: 9,
      y: 4,
      anchor: {
        x: 0,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'CHANCE!',
      localize: true,
      maxWidth: 307,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 58,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#DA1730',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 660,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'c294edbf-39b6-445f-9cb0-57e5dce49f6c',
    },
    {
      id: '673a8240-e9e9-475b-949d-aed6d22a8a4f',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 18,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      text: 'Value!',
      localize: true,
      maxWidth: 106,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#8D2400',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'c0b4e04e-62d5-48a6-8c6a-0d1f4d536c11',
      stateByName: {
        claimable_lastChance: {
          style: {
            stroke: '#153E82',
          },
        },
      },
    },
    {
      id: '62559624-3972-4fe3-ae08-7ea132269b78',
      type: 'Text',
      name: 'percentageText',
      className: '',
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      text: '120%',
      localize: false,
      maxWidth: 107,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#8D2400',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'c0b4e04e-62d5-48a6-8c6a-0d1f4d536c11',
      stateByName: {
        claimable_lastChance: {
          style: {
            stroke: '#153E82',
          },
        },
      },
    },
    {
      id: '72ec7e5a-30a1-4a5e-8ae2-a73f4bf986fa',
      type: 'Sprite',
      name: '',
      className: '',
      x: -201,
      y: 39,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: '40153f84-2118-4824-8547-8dc2781986ba',
      type: 'Sprite',
      name: '',
      className: '',
      x: -225,
      y: 126,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: '9a2c30f4-0ece-479e-9752-b9faf87fe94d',
      type: 'Sprite',
      name: '',
      className: '',
      x: -235,
      y: 98,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: '737969f1-8fe0-42af-9fc9-ca3af92ef859',
      type: 'Sprite',
      name: '',
      className: '',
      x: -213,
      y: 193,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: '2ba86c22-3242-44df-baf9-98567c16fe94',
      type: 'Sprite',
      name: '',
      className: '',
      x: 217,
      y: 164,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: '0da91496-be8d-4a75-8040-e3e2547a4cd0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 192,
      y: 104,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: 'ddaeed96-482a-4183-a048-2e2ceb237c15',
      type: 'Sprite',
      name: '',
      className: '',
      x: 153,
      y: 11,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: '9741a66b-323d-4a3f-bf50-b6225a81bfd0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 194,
      y: 78,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: 'd95f5602-0f11-4fb9-9822-1e510d5f8cfe',
      type: 'Sprite',
      name: '',
      className: '',
      x: 218,
      y: 51,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: '8ae87276-3153-4944-8539-c80662fa5fb6',
      type: 'Sprite',
      name: '',
      className: '',
      x: 205,
      y: 141,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: '52c648f5-0c6c-4985-a432-bab3cbb54758',
      type: 'Sprite',
      name: '',
      className: '',
      x: 135,
      y: 224,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e0f10d13-155f-42b1-8bc3-536299d63d80',
    },
    {
      id: '7a151185-014c-496b-8aed-337ea588961e',
      type: 'Sprite',
      name: '',
      className: '',
      x: -216,
      y: 12,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: '3a8e6777-ae2d-4ddc-9a50-d8f2ea21cefe',
      type: 'Sprite',
      name: '',
      className: '',
      x: -209,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: '5aa1e239-e543-4598-ad97-411d2e633964',
      type: 'Sprite',
      name: '',
      className: '',
      x: -252,
      y: 74,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: 'd0765271-9efa-4c21-b3bc-547a0d2bb669',
      type: 'Sprite',
      name: '',
      className: '',
      x: -223,
      y: 167,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: 'f4cc07f5-5ab1-4d0d-b08e-af3032415847',
      type: 'Sprite',
      name: '',
      className: '',
      x: -279,
      y: 188,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: -60.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: '911f2d26-3b06-4660-9861-ad2fbc4ea593',
      type: 'Sprite',
      name: '',
      className: '',
      x: 153,
      y: 11,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: '9b972936-dfc6-4d14-8395-ca4adb5d5a12',
      type: 'Sprite',
      name: '',
      className: '',
      x: 194,
      y: 78,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: '56b29bb7-bfda-4f8b-80a2-073754dee811',
      type: 'Sprite',
      name: '',
      className: '',
      x: 218,
      y: 51,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: 'cba9707c-f932-4e1a-9612-66c34f4c9bc7',
      type: 'Sprite',
      name: '',
      className: '',
      x: 209,
      y: 28,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: '91be2825-e607-4d05-bd22-41ae650231fd',
      type: 'Sprite',
      name: '',
      className: '',
      x: 220,
      y: 2,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: '34e3860f-02fe-4a91-b7b4-14f38ffb67a8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 211,
      y: -22,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: '51387315-6993-47b0-9414-8326d128afd5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 215,
      y: 115,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: '01d9a434-5b8b-4a95-813c-8c434465c9d9',
      type: 'Sprite',
      name: '',
      className: '',
      x: 145,
      y: 200,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: 'c52553c2-481f-4f7f-bf1c-14365e3d3344',
      type: 'Sprite',
      name: '',
      className: '',
      x: 39,
      y: 259,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coin',
      parent: 'e9bdf5a8-466e-4abb-8572-4983a2acf581',
    },
    {
      id: 'f29f770e-c44e-4c6e-8b32-6d9db573766f',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: 14,
      y: 18,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      width: 471,
      height: 50,
      leftWidth: 19,
      topHeight: 0,
      rightWidth: 19,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coins_Counter_Bar_Empty_9Slice_19x0x19x0',
      parent: 'a16e384a-a1cc-4bb7-a01e-b012a55b97b7',
    },
    {
      id: '6312b4bb-5701-405f-bb13-726e6e77bb43',
      type: 'NineSlicePlane',
      name: 'progressBar',
      className: '',
      x: 14,
      y: 18,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      width: 471,
      height: 50,
      leftWidth: 19,
      topHeight: 0,
      rightWidth: 19,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Piggy_Bank_Coins_Counter_Bar_Full_9Slice_19x0x19x0',
      parent: 'a16e384a-a1cc-4bb7-a01e-b012a55b97b7',
    },
    {
      id: '5585abe9-5dbb-4185-a16c-94e6d3292c83',
      type: 'Text',
      name: 'progressText',
      className: '',
      x: 250,
      y: 41,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      text: '50 / 700',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#8D2400',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'a16e384a-a1cc-4bb7-a01e-b012a55b97b7',
      stateByName: {
        claimable_tier: {
          style: {
            fontSize: 40,
          },
        },
        claimable_lastChance: {
          style: {
            fontSize: 40,
          },
        },
      },
    },
    {
      id: 'b8c41e0d-cba2-4b76-b2c3-3ce5b96a4fd0',
      type: 'Graphics',
      name: 'progressBarMask',
      className: '',
      x: 14,
      y: 18,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'a16e384a-a1cc-4bb7-a01e-b012a55b97b7',
      commands: [
        {
          id: 'd5072b90-385f-4571-aee1-7a294737de0f',
          type: 'beginFill',
          color: 16777215,
          alpha: 1,
        },
        {
          id: 'c78fda15-dcca-4f92-a6de-2f8506fbef26',
          type: 'drawRoundedRect',
          x: 0,
          y: 0,
          width: 471,
          height: 50,
          radius: 38,
        },
        {
          id: 'c474d097-c2b4-45b1-b682-d6f15961efb2',
          type: 'beginFill',
          color: 16777215,
          alpha: 1,
        },
      ],
    },
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '1.0.0',
  stateNames: [
    'claimable',
    'unclaimable',
    'inProgressAnimation',
    'inClaimAnimation',
    'unclaimable_tier',
    'claimable_tier',
    'claimable_lastChance',
  ],
  handleResize: false,
} as const;

export class PiggyBankOverlayLayout {
  static raw = raw;
  root!: Container;
  redBackgroundContainer!: Container;
  blueBackgroundContainer!: Container;
  foreground!: Container;
  coinCounterSlot!: Container;
  redBackground!: Graphics & { data: (typeof raw)['list'][5]['data'] };
  redGradient!: Sprite & { data: (typeof raw)['list'][6]['data'] };
  blueBackground!: Graphics & { data: (typeof raw)['list'][7]['data'] };
  blueGradient!: Sprite & { data: (typeof raw)['list'][8]['data'] };
  logo!: PiggyBankTitleLocalizationsLayout;
  raysContainer!: Container;
  raysMask!: Graphics;
  closeButton!: Sprite;
  ctaText!: Text;
  lastChanceContainer!: Container;
  stickerContainer!: Container;
  content!: Container;
  progressBarContainer!: Container;
  claimButton!: ButtonLargeLayout & { data: (typeof raw)['list'][20]['data'] };
  playButton!: ButtonLargeLayout & { data: (typeof raw)['list'][21]['data'] };
  particleLayerSlot!: Container;
  rewardContainer!: Container;
  coinParticleSlot!: Container;
  timerContainer!: Container;
  nextTierContainer!: Container;
  rays!: Sprite & { data: (typeof raw)['list'][27]['data'] };
  coinsEmpty!: Container;
  coinsFull!: Container;
  pigLayout!: PiggyBankLayout;
  pigSlot!: Container;
  speechBubble!: Sprite;
  fullTextSmall!: Text;
  claimButtonText!: Text;
  loadingSpinnerSlot!: Container;
  playButtonLevelText!: Text;
  coinSprite!: Sprite;
  coinsAmountText!: Text;
  timerText!: Text;
  emptyText!: Text;
  nextTierLayout!: PiggyBankSmallLayout;
  percentageText!: Text;
  progressBar!: NineSlicePlane;
  progressText!: Text;
  progressBarMask!: Graphics;
  dynamicProps_SPL!: (
    | (Graphics & { data: (typeof raw)['list'][5]['data'] })
    | (Sprite & { data: (typeof raw)['list'][6]['data'] })
    | (Graphics & { data: (typeof raw)['list'][7]['data'] })
    | (Sprite & { data: (typeof raw)['list'][8]['data'] })
  )[];
  rotate_SPL!: (Sprite & { data: (typeof raw)['list'][27]['data'] })[];
  colorTags_SPL!: (Text & { data: (typeof raw)['list'][28]['data'] })[];
  upperCase_SPL!: Text[];
  StateName!:
    | 'claimable'
    | 'unclaimable'
    | 'inProgressAnimation'
    | 'inClaimAnimation'
    | 'unclaimable_tier'
    | 'claimable_tier'
    | 'claimable_lastChance';

  constructor() {
    populate(this, raw);
  }
}
